// extracted by mini-css-extract-plugin
export default {"root":"N5K6TfXDwd_3ZTRpNSVV","content":"zobHQirTeuQovFQi0fTT","title":"r0CIJagx9_AGJt_U2X6J","description":"XmB5qNTtFG0m3F73VpMG","logo":"xjJFERe0Bq3vetaBD6ba"};